import React from 'react';

import Index from './containers/index';

import './App.css';

function App() {
  return (
    <div className='App'>
      <Index />
    </div>
  );
}

export default App;
